import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Bot, Settings, Bug, Database } from 'lucide-react';
import FrankApiSettingsForm from '@/components/admin/frank-settings/FrankApiSettingsForm';
import FrankDebugPanel from '@/components/admin/FrankDebugPanel';
import FrankLogsViewer from '@/components/admin/FrankLogsViewer';

const FrankManagement = () => {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center gap-3">
        <Bot className="w-8 h-8 text-primary" />
        <div>
          <h1 className="text-3xl font-bold">Frank AI Management</h1>
          <p className="text-muted-foreground">
            Configure, monitor, and debug Frank AI integration
          </p>
        </div>
      </div>

      <Tabs defaultValue="settings" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Settings className="w-4 h-4" />
            Settings
          </TabsTrigger>
          <TabsTrigger value="debug" className="flex items-center gap-2">
            <Bug className="w-4 h-4" />
            Debug
          </TabsTrigger>
          <TabsTrigger value="logs" className="flex items-center gap-2">
            <Database className="w-4 h-4" />
            Logs
          </TabsTrigger>
        </TabsList>

        <TabsContent value="settings" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Frank AI Configuration</CardTitle>
              <CardDescription>
                Configure Frank AI API settings for your organization
              </CardDescription>
            </CardHeader>
            <CardContent>
              <FrankApiSettingsForm />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="debug" className="space-y-4">
          <FrankDebugPanel />
        </TabsContent>

        <TabsContent value="logs" className="space-y-4">
          <FrankLogsViewer />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default FrankManagement;